<!--
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2023-09-25 19:31:59
 * @LastEditors: renxin
 * @LastEditTime: 2024-04-17 17:35:11
 * @FilePath: /h5/src/views/product/detail/components/extra-product/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%
-->
<!--  -->
<template>
  <div
    class="extra-product-container"
    v-track="{
      act: 'show',
      params: {
        cfrom: '081|077|02|077',
        event_id: '081|077|02|077',
        sku_id: skuId
      }
    }"
  >
    <div class="header" tabindex="0">
      <div class="title">超值加购</div>
      <div class="sub-title" :class="subDesc ? 'sub-red' : ''" v-text="subDesc ? subDesc : '精选好物随心配'"></div>
    </div>
    <div class="content">
      <div class="product-info" v-for="(item, index) in showAdditCommInfo" :key="item.skuId">
        <div class="tag" aria-hidden="true" v-if="item.savePrice">
          <span class="tag-text" v-text="`省${item.savePrice}元`"></span>
        </div>
        <div tabindex="0" @click="goToDetail(item)">
          <div class="detail">
            <img v-lazy="item.imgUrl" alt="" />
            <div class="name lc-1">{{ item.skuShortName }}</div>
          </div>
          <div class="price">
            <span class="sale-price" :aria-label="`活动价${item.activityPrice}元`" v-text="item.activityPrice"></span>
            <span
              class="line-price"
              :aria-label="`原价${item.salePrice}元，省${item.savePrice}元`"
              v-if="item.savePrice"
              v-text="`￥${item.salePrice}`"
            ></span>
          </div>
          <div :aria-label="`第${index + 1}个，共${showAdditCommInfo.length}个，点击可查看商品详情`"></div>
        </div>
        <div
          class="select-container"
          tabindex="0"
          role="checkbox"
          :aria-checked="`${additionSkuList.includes(item.skuId) ? 'true' : 'false'}`"
          @click.stop="selectSku(item)"
        >
          <div class="selected" aria-hidden="true" :class="additionSkuList.includes(item.skuId) ? 'unselected' : ''">
            <v-icon class="icon" name="check-mark"></v-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapActions, mapGetters } from 'vuex'
import { formatNumber } from 'utils/common'
import { app } from '@/utils'
export default {
  name: 'extraProduct',
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      productList: []
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState('detailv3', ['additionCommodityInfo', 'showAdditCommInfo', 'selectParams']),
    ...mapGetters('detailv3', ['skuId']),
    // 已选加购商品信息
    additionCommodity() {
      return this.selectParams.additionCommodity
    },
    // 已选加购商品的sku信息
    additionSkuList() {
      const list = []
      this.additionCommodity.forEach(el => {
        list.push(el.skuId)
      })
      return list
    },
    subDesc() {
      let money = 0
      if (this.additionSkuList.length) {
        // 如果有选中的加购商品，则计算节省多少钱
        this.additionCommodity.forEach(el => {
          money = money + el.savePrice
        })
        // 如果有节省，则返回节省多少钱
        if (money) {
          return `共省${formatNumber(money)}元`
        }
      }
      // 如果没节省，则计算目前显示的所有加购商品最多可以省多少钱
      if (!money) {
        this.showAdditCommInfo.forEach(el => {
          money = money + el.savePrice
        })
      }
      if (money) {
        return `最多可省${formatNumber(money)}元`
      } else {
        // 如果没有节省，则返回空字符串，显示默认文案
        return ''
      }
    }
  },
  //方法集合
  methods: {
    ...mapActions('detailv3', ['addAdditionCommodity', 'removeAdditionCommodity']),
    selectSku(skuItem) {
      // 取消选中
      if (this.additionSkuList.includes(skuItem.skuId)) {
        this.removeAdditionCommodity(skuItem)
        this.$track({
          cfrom: '081|077|01|077',
          event_id: '081|077|01|077',
          content: skuItem.skuId,
          sku_id: this.skuId,
          clickPos: 3
        })
      } else {
        // 选中
        this.addAdditionCommodity(skuItem)
        this.$track({
          cfrom: '081|077|01|077',
          event_id: '081|077|01|077',
          content: skuItem.skuId,
          sku_id: this.skuId,
          clickPos: 2
        })
      }
    },
    goToDetail(skuItem) {
      this.$track({
        cfrom: '081|077|01|077',
        event_id: '081|077|01|077',
        content: skuItem.skuId,
        sku_id: this.skuId,
        clickPos: 1
      })
      const link = `${this.linkBase}/product/${skuItem.spuId}?skuId=${skuItem.skuId}`
      app.openNewWebview({
        url: link
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.initProductList()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss" src="./index.scss" scoped></style>
